import { httpClient } from '../httpClient';

export const privilegeReviewApi = {
  /** GET /privilege-reviews/ — paginated list, optional status filter */
  listReviews: (params) =>
    httpClient.get('/privilege-reviews/', { params }),

  /** GET /privilege-reviews/:id — single review */
  getReview: (id) =>
    httpClient.get(`/privilege-reviews/${id}`),

  /** POST /privilege-reviews/ — create a new review */
  createReview: (data) =>
    httpClient.post('/privilege-reviews/', data),

  /** PUT /privilege-reviews/:id — update review */
  updateReview: (id, data) =>
    httpClient.put(`/privilege-reviews/${id}`, data),

  /** GET /privilege-reviews/upcoming — check if review is due soon */
  getUpcoming: () =>
    httpClient.get('/privilege-reviews/upcoming'),

  /** GET /privilege-reviews/stats — KPI counts for the ribbon */
  getStats: () =>
    httpClient.get('/privilege-reviews/stats'),

  /** GET /privilege-reviews/roster — active privileged-access population (H1 grounding) */
  getRoster: () =>
    httpClient.get('/privilege-reviews/roster'),

  /** GET /privilege-reviews/remediations — org-level remediations, optional status filter */
  getRemediations: (params) =>
    httpClient.get('/privilege-reviews/remediations', { params }),

  /** POST /privilege-reviews/remediations/:id/enact — move subject to target_role_id */
  enactRemediation: (id, data) =>
    httpClient.post(`/privilege-reviews/remediations/${id}/enact`, data),

  /** POST /privilege-reviews/remediations/:id/close — close with required closure_note */
  closeRemediation: (id, data) =>
    httpClient.post(`/privilege-reviews/remediations/${id}/close`, data),

  /** POST /privilege-reviews/remediations/:id/cancel — cancel with required closure_note */
  cancelRemediation: (id, data) =>
    httpClient.post(`/privilege-reviews/remediations/${id}/cancel`, data),
};
